import React from 'react';
import { SitecoreImageField, SitecoreLinkField } from 'components/sitecore-fields';
import Cookies from 'js-cookie';
import { CookieNames } from '../../../../general/js/utils/cookies';
import Oauth from '../../../sso/components/oauth';

class MastercardRegistrationForm extends React.Component {
    constructor(...args) {
        super(...args);

        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleFieldChangeFocus = this.handleFieldChangeFocus.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.extractUserDetailsFromCookie = this.extractUserDetailsFromCookie.bind(this);
    }

    extractUserDetailsFromCookie() {
        const userDataCookie = Cookies.get(CookieNames.TOCH_USER_DATA);
        const userObject = {
            userName: '',
            postcode: ''
        };


        if (userDataCookie === undefined || userDataCookie === null) return userObject;

        const userData = JSON.parse(userDataCookie);

        userObject.userName = `${userData.firstName} ${userData.lastName}`;
        userObject.postcode = userData.postcode;

        return userObject;
    }

    handleSubmit() {
        Oauth.mastercardUpgrade();
    }

    handleFieldChange(e, fieldName) {
        const { handleChange } = this.props;

        handleChange(e, fieldName);
    }

    handleFieldChangeFocus(e) {
        const { handleOnChangeFocus } = this.props;

        handleOnChangeFocus(e);
    }

    render() {
        const {
            backgroundImage,
            masterCardLogo,
            title,
            bottomInfo,
            ctaSignUpForMastercardLink,
        } = this.props;

        return (
            <div className="mastercard-registration__wrap">
                <div className="mastercard-registration__media">
                    <div className="mastercard-registration__media--wrapper">
                        <SitecoreImageField img={backgroundImage} className='mastercard-registration__media--backgroundImage' />
                    </div>
                </div>
                <div className="mastercard-registration__content">
                    <div className="mastercard-registration__head mastercard-branding-left">
                        <div className='mastercard-branding'>
                            <SitecoreImageField img={masterCardLogo} className='mastercard-branding--logo' />
                        </div>
                    </div>
                    <div className="mastercard-registration__wrapper">
                        <div className="mastercard-registration__heading">
                            <h2 className="mastercard-registration__title">{title}</h2>
                        </div>
                        <form className="mastercard-registration__form">
                            <div className="mastercard-registration__form--row">
                                <p className="mastercard-registration__form--info">{bottomInfo}</p>
                            </div>
                            <div className="mastercard-registration__form--row">
                                <SitecoreLinkField className="mastercard-registration__form--link" link={ctaSignUpForMastercardLink}>
                                    <svg
                                        className="icon button__arrow-right"
                                        width="14" height="12"
                                        focusable="false">
                                        <use xlinkHref="#icon-arrow-right">
                                        </use>
                                    </svg>
                                </SitecoreLinkField>

                                <div className="mastercard-registration__form--button">
                                    <button
                                        type="button"
                                        className="button button--primary"
                                        onClick={this.handleSubmit}
                                    >
                                        <span className="button-content">
                                            Upgrade
                                        </span>
                                    </button>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default MastercardRegistrationForm;
